import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { Link } from 'react-router-dom'
import { subpageTypes } from './ModuleSubpage'
import '../assets/css/components/module-navbar.css'

const ModuleNavbar = ({ handleSubpageSelect, module, currentSubpage }) => {
  const buttonText = (buttonSubpage) => {
    switch(buttonSubpage) {
      case subpageTypes.OVERVIEW:
        return 'Overview'
      case subpageTypes.SEQUENCES:
        return 'Storylines'
      case subpageTypes.SANDBOX:
        return 'Sandbox'
      case subpageTypes.PRACTICE:
        return 'Practice'
      case subpageTypes.ENRICHMENT:
        return 'Enrichment'
      case subpageTypes.SEARCH:
        return 'Search All'
      default:
        return ''
    }
  }

  const renderButton = (buttonSubpage) => (
    <Link
      key={buttonSubpage}
      to={`/modules/${module.id}/${buttonSubpage.toLowerCase()}`}
      onClick={()=>handleSubpageSelect(buttonSubpage)}
      className={`btn btn-default btn-lg btn-larger module-subpage-nav-btn ${currentSubpage === buttonSubpage ? 'selected' : ''}`}>
      {buttonText(buttonSubpage)}
    </Link>
  )

  // Don't include the SANDBOX type if there's no sandbox content for
  // that particular module.
  const getTypes = ()=> {
    let types = Object.assign({}, subpageTypes)
    if(!module.sandbox_description) {
      delete types.SANDBOX
    }

    return types;
  }

  return(
    <div className='module-navbar-container'>
      <div className='module-navbar'>
        {_.map(getTypes(), (values, key)=> {
          return renderButton(key)
        })}
      </div>
    </div>
  )
}

const { func, string } = PropTypes
ModuleNavbar.propTypes = {
  handleSubpageSelect: func.isRequired,
  currentSubpage:      string.isRequired
}

export default ModuleNavbar
